export default "__VITE_ASSET__COGDlJ1j__"